import {type JobMatchCriterionDetail} from '../types/TalentPoolProfileTypes';

import {AssessmentQuestion} from '../../../../../types/shared-recruiting-types';

function legacyCriteriaLine(item: unknown): string {
  if (typeof item === 'string') {
    return item;
  }
  if (item && typeof item === 'object') {
    const record = item as Record<string, unknown>;
    if (typeof record.text === 'string') {
      return record.text;
    }
    if (typeof record.summary === 'string') {
      return record.summary;
    }
    if (typeof record.label === 'string') {
      return record.label;
    }
  }
  return '';
}

export function parseCriterionDetail(raw: unknown): JobMatchCriterionDetail | null {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const record = raw as Record<string, unknown>;
  if (typeof record.criterion === 'string') {
    return {
      criterion: record.criterion,
      explanation: typeof record.explanation === 'string' ? record.explanation : undefined,
      met: typeof record.met === 'boolean' ? record.met : undefined,
    };
  }
  const line = legacyCriteriaLine(raw);
  return line ? {criterion: line} : null;
}

/** BE may send `multiple_choice`; `AssessmentResults` treats non-`single_choice` as multi-select. */
export function normalizeAssessmentQuestions(
  questions: AssessmentQuestion[] | undefined,
): AssessmentQuestion[] | undefined {
  if (!questions?.length) {
    return questions;
  }
  return questions.map((question) => {
    const rawType = question.type as string;
    const type: AssessmentQuestion['type'] =
      rawType === 'multiple_choice' || rawType === 'multi_choice'
        ? 'multi_choice'
        : rawType === 'single_choice'
          ? 'single_choice'
          : 'text';

    return {...question, type};
  });
}
